import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useActiveTemplateId } from './use-active-project-template';
const getAllTasksSelector = ()=>createSelector((state)=>state.templates.project, (_, templateId)=>templateId, (project, templateId)=>project.data[templateId].tasks);
export const useGetAllTasks = ()=>{
    const templateId = useActiveTemplateId();
    const templateObject = useMemo(getAllTasksSelector, []);
    return useSelector((state)=>templateObject(state, templateId));
};
